<template>
  <v-container v-if="person" fluid>
    <v-row v-if="person.intro_video">
      <v-col cols="12">
        <v-card class="mb-6" color="primary" rounded="0">
          <VideoCover
            :aspect-ratio="videoAspectRatio"
            :gradient="TRAINER_VIDEO_GRADIENT"
            :value="person.intro_video"
            content-class="d-flex align-center justify-center"
          >
            <PlayVideo
              v-if="!video"
              :title="`About ${person.name}`"
              :video="person.intro_video"
              @click="() => (video = person.intro_video)"
            />
            <VideoPlayer v-else :value="video" />
          </VideoCover>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="flex-grow-0">
        <v-avatar class="elevation-6 widget-trainer-about-avatar" size="180">
          <ImageCover
            :value="person"
            default-key="person_default_image"
            image-key="list_image"
            max-width="170"
            width="170"
          />
        </v-avatar>
      </v-col>

      <v-col align-self="center" cols="12" sm="">
        <h2 class="text-h3 font-weight-medium mb-2">{{ person.name }}</h2>
        <h3 class="text-h5 font-weight-medium">{{ person.title }}</h3>
      </v-col>
    </v-row>

    <v-row v-if="person.description" :class="isMoreHidden ? 'fade' : ''">
      <v-col cols="12">
        <!-- eslint-disable vue/no-v-html -->
        <div class="text-body-1" v-html="person.description"></div>
      </v-col>
    </v-row>

    <v-row v-if="person.description">
      <v-col class="text-center">
        <v-btn
          class="text-none ma-1"
          exact
          rounded="pill"
          size="large"
          @click.stop="toggleMore()"
        >
          {{ isMoreHidden ? 'Read More' : 'Read Less' }}</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref } from 'vue'
import { useToggle } from '@vueuse/core'
import { TRAINER_VIDEO_GRADIENT } from '#root/lib/consts'

defineProps({
  person: {
    required: true,
    type: Object
  }
})

const [isMoreHidden, toggleMore] = useToggle(true)
const videoAspectRatio = 16 / 9
const video = ref(null)
</script>

<style>
.fade {
  max-height: 220px;
  -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
}

.widget-trainer-about-avatar {
  border-color: white;
  border-style: solid;
  border-width: 11px;
}
</style>
